import { useTranslation } from 'react-i18next'

import { learnArticlePath } from '@/features/aprender/articles'
import { LocaleLink } from '@/navigation/LocaleLink'

export function FaqLearnArticleLink({ articleId }: { articleId: string }) {
    const { t } = useTranslation()

    return (
        <LocaleLink
            to={learnArticlePath(articleId)}
            className='mt-3 inline-block text-sm font-semibold text-[#F4502A] no-underline'
        >
            {t('faqPage.readLearnArticle', 'Leer guía completa →')}
        </LocaleLink>
    )
}
